import { useState } from "react";
import { toast } from "sonner";
import { Loader2, Lock } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { validatePassword } from "../../lib/api";

const FIELD = "w-full border border-border bg-secondary px-4 py-3 text-sm outline-none transition-colors placeholder:text-muted-foreground focus:border-brand";

export default function SetPasswordDialog({ open, onSubmit }) {
  const [p1, setP1] = useState("");
  const [p2, setP2] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    const err = validatePassword(p1);
    if (err) return toast.error(err);
    if (p1 !== p2) return toast.error("Passwords do not match.");
    setSaving(true);
    try { await onSubmit(p1); toast.success("Password updated."); }
    catch { toast.error("Could not update password. Please try again."); }
    finally { setSaving(false); }
  };

  return (
    <Dialog open={open}>
      <DialogContent className="border-border bg-card sm:max-w-md [&>button]:hidden" data-testid="set-password-dialog">
        <DialogHeader>
          <div className="flex items-center gap-2 text-brand"><Lock size={16} /><span className="font-mono text-[11px] uppercase tracking-[0.2em]">Secure your account</span></div>
          <DialogTitle className="mt-2 font-display text-2xl font-light tracking-tighter">Set your password</DialogTitle>
        </DialogHeader>
        <p className="text-sm text-muted-foreground">Welcome! For your security, please replace your temporary password before continuing.</p>
        <form onSubmit={submit} className="mt-2 space-y-4">
          <input type="password" value={p1} onChange={(e) => setP1(e.target.value)} placeholder="New password" className={FIELD} data-testid="set-password-new" />
          <input type="password" value={p2} onChange={(e) => setP2(e.target.value)} placeholder="Confirm new password" className={FIELD} data-testid="set-password-confirm" />
          <p className="text-[11px] leading-relaxed text-muted-foreground">Must be at least 10 characters and include an uppercase letter, a number, and a symbol.</p>
          <button type="submit" disabled={saving} data-testid="set-password-submit" className="inline-flex w-full items-center justify-center gap-2 bg-brand px-6 py-4 font-mono text-xs uppercase tracking-[0.15em] text-white transition-colors hover:bg-navy disabled:opacity-60">
            {saving ? <Loader2 size={16} className="animate-spin" /> : <Lock size={16} />} Save password
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
